import {GlobalValidationsState} from '../types/mx/reducers';
import {CommonCalculatorConfig} from '../types/mx/components';

export const globalValidationInit: GlobalValidationsState = {
    creditoReal: {
        minAllowedAge: 21,
        minAllowedVehiclePrice: 0,
        minDownPayment: 0.2,
        maxDownPayment: 0.89,
        monthlyRate: 0.0178
    } as CommonCalculatorConfig,
    turboCash: {
        minAllowedAge: 21,
        minAllowedVehiclePrice: 0,
        minDownPayment: 0.3,
        maxDownPayment: 0.89,
        monthlyRate: 0.0178
    } as CommonCalculatorConfig,
    configByProfile: {
        minAllowedAge: 21,
        minAllowedVehiclePrice: 0,
        minDownPayment: 0.2,
        maxDownPayment: 0.89,
        monthlyRate: 0.0178
    } as CommonCalculatorConfig,
    smsTimerResend: 30
};